import { render } from "./SettingsSvg.vue?vue&type=template&id=7a7a5157"
import script from "./SettingsSvg.vue?vue&type=script&lang=js"
export * from "./SettingsSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__